"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BriefcaseOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_BriefcaseOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.5v-1a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1h1.143C15.168 3.5 16 4.331 16 5.357v2.286c0 .49-.19.936-.5 1.268v4.732a1.857 1.857 0 0 1-1.857 1.857H2.357A1.857 1.857 0 0 1 .5 13.643V8.91A1.85 1.85 0 0 1 0 7.643V5.357C0 4.331.831 3.5 1.857 3.5H3Zm2-2h6a1 1 0 0 1 1 1v1H4v-1a1 1 0 0 1 1-1Zm-3.143 3A.857.857 0 0 0 1 5.357v2.286c0 .473.384.857.857.857h12.286A.857.857 0 0 0 15 7.643V5.357a.857.857 0 0 0-.857-.857H1.857ZM6 9.5h4v1H6v-1Zm-1 1.393V9.5H1.5v4.143c0 .473.384.857.857.857h11.286a.857.857 0 0 0 .857-.857V9.5H11v1.393a.607.607 0 0 1-.607.607H5.607A.607.607 0 0 1 5 10.893Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_BriefcaseOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = BriefcaseOutline;
exports["default"] = _default;